<template>
<div id="main" v-if="metadata && isShow && questions">
    <div v-if="!isMoodStatus && !isUserStatus" id="container">
        <header>プロフィール登録</header>
        <div id="wrap">
            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/reg-f.jpg">
            <img v-else src="~@/assets/images/reg-m.jpg">
            <div class="chat-bc" id="profile_register_main" style="margin-bottom:60px">
                <!-- height -->
                <div class="balloon" v-if="parseInt(user.sex) === FEMALE">
                    <div class="faceicon">
                        <img src="~@/assets/images/avatar_bot_female.png">
                    </div>
                    <div class="chatting">
                        <div class="says">
                            <p v-html="getQuestionItem(questions.height.content, 'job')"></p>
                        </div>
                    </div>
                </div>
                <div class="mycomment" v-if="formData.height && parseInt(user.sex) === FEMALE">
                    <p>{{ getFieldProfile('height',formData.height) }}</p>
                </div>
                <!-- style -->
                <div class="balloon" v-if="formData.height && parseInt(user.sex) === FEMALE">
                    <div class="faceicon">
                        <img src="~@/assets/images/avatar_bot_female.png">
                    </div>
                    <div class="chatting">
                        <div class="says">
                            <p v-html="getQuestionItem(questions.style.content, 'job')"></p>
                        </div>
                    </div>
                </div>
                <div class="mycomment" v-if="formData.style">
                    <p>{{ getFieldProfile('style',formData.style) }}</p>
                </div>
                <!-- job -->
                <div class="balloon" v-if="formData.style && parseInt(user.sex) === FEMALE || parseInt(user.sex) !== FEMALE">
                    <div class="faceicon">
                        <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                        <img v-else src="~@/assets/images/prof1.jpg">
                    </div>
                    <div class="chatting">
                        <div class="says">
                            <p v-html="getQuestionItem(questions.job.content, 'job')"></p>
                        </div>
                    </div>
                </div>
                <div class="mycomment" v-if="formData.job">
                    <p>{{ getFieldProfile('job',formData.job) }}</p>
                </div>
                <!-- income -->
                <div v-if="formData.job && parseInt(user.sex) !== FEMALE">
                    <div class="balloon">
                        <div class="faceicon"><img src="~@/assets/images/prof1.jpg"></div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.income.content,  'income')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mycomment" v-if="formData.income">
                        <p>{{ getFieldProfile('income',formData.income) }}</p>
                    </div>
                </div>
                <!-- holidays -->
                <div v-if="(formData.income && parseInt(user.sex) !== FEMALE) || formData.job && parseInt(user.sex) === FEMALE">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.holiday.content,  'holidays')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mycomment" v-if="formData.holidays">
                        <p>{{ getFieldProfile('holidays',formData.holidays) }}</p>
                    </div>
                </div>
                <!-- meeting_condition -->
                <div v-if="formData.holidays">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.meeting_condition.content,  'meeting_condition')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mycomment" v-if="formData.meeting_condition">
                        <p>{{ getFieldProfile('meeting_condition',formData.meeting_condition) }}</p>
                    </div>
                </div>
                <!-- purpose -->
                <div v-if="formData.meeting_condition">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.purpose.content,  'meeting_condition')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mycomment" v-if="formData.purpose">
                        <p>{{ getFieldProfile('purpose',formData.purpose) }}</p>
                    </div>
                    <div class="balloon" v-if="formData.purpose">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.thank_you.content,  'thank_you')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="balloon" v-if="formData.purpose">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.summary.content,  'summary')"></p>
                            </div>
                        </div>
                    </div>
                    <div id="mycomment2" v-if="formData.purpose">
                        <div class="mycomment2">
                            <table>
                                <tr v-if="parseInt(user.sex) === FEMALE">
                                    <td class="my1">身長</td>
                                    <td class="my2" id="mycomment2_height">{{ getFieldProfile('height', formData.height) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isHeight = true"></i></td>
                                </tr>
                                <tr v-if="parseInt(user.sex) === FEMALE">
                                    <td class="my1">体型</td>
                                    <td class="my2" id="mycomment2_style">{{ getFieldProfile('style', formData.style) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isStyle = true"></i></td>
                                </tr>
                                <tr>
                                    <td class="my1">職業</td>
                                    <td class="my2" id="mycomment2_job">{{ getFieldProfile('job', formData.job) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isJob = true"></i></td>
                                </tr>
                                <tr v-if="parseInt(user.sex) !== FEMALE">
                                    <td class="my1">年収</td>
                                    <td class="my2" id="mycomment2_income">{{ getFieldProfile('income', formData.income) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isIncome = true"></i></td>
                                </tr>
                                <tr>
                                    <td class="my1">休日</td>
                                    <td class="my2" id="mycomment2_holidays">{{ getFieldProfile('holidays', formData.holidays) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isHolidays = true"></i></td>
                                </tr>
                                <tr>
                                    <td class="my1">出会うまでの希望</td>
                                    <td class="my2" style="padding-left:10px" id="mycomment2_meeting_condition">{{ getFieldProfile('meeting_condition', formData.meeting_condition) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isMeetingCondition = true"></i></td>
                                </tr>
                                <tr>
                                    <td class="my1">会ったときの希望</td>
                                    <td class="my2" id="mycomment2_purpose">{{ getFieldProfile('purpose', formData.purpose) }}</td>
                                    <td class="my3"><i class="fas fa-edit" @click="isEdit = true; isPurpose = true"></i></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- mood_status -->
                <div v-if="formData.purpose">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.mood_user_status.content,  'meeting_condition')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mycomment2" v-if="formData.mood_status">
                        <table>
                            <tbody>
                                <tr>
                                    <td class="my4">ひとこと</td>
                                    <td class="my2"></td>
                                    <td class="my3"><a @click="isEdit = true; isMoodStatus = true"><i class="fas fa-edit" aria-hidden="true"></i></a></td>
                                </tr>
                            </tbody>
                        </table>
                        <div align="left" style="word-break: break-word;">{{ formData.mood_status }}</div>
                    </div>
                    <div class="mycomment2 mt10" v-if="formData.user_status">
                        <table>
                            <tbody>
                                <tr>
                                    <td class="my4">自己紹介</td>
                                    <td class="my2"></td>
                                    <td class="my3"><a @click="isEdit = true; isUserStatus = true"><i class="fas fa-edit" aria-hidden="true"></i></a></td>
                                </tr>
                            </tbody>
                        </table>
                        <div align="left" style="word-break: break-word;">{{ formData.user_status }}</div>
                    </div>
                </div>
                <!-- done -->
                <div v-if="formData.mood_status && formData.user_status">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.done_1.content,  'done_1')"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- done -->
                <div v-if="formData.mood_status && formData.user_status">
                    <div class="balloon">
                        <div class="faceicon">
                            <img v-if="parseInt(user.sex) === FEMALE" src="~@/assets/images/avatar_bot_female.png">
                            <img v-else src="~@/assets/images/prof1.jpg">
                        </div>
                        <div class="chatting">
                            <div class="says">
                                <p v-html="getQuestionItem(questions.done_2.content,  'done_2')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn1 submit-btn" id="profile_finish" v-if="isFinish"><a @click="$emit('submit', formData)">完了</a></div>
            <div class="btn1 submit-btn" v-if="!isOpenMoodStatus && !isOpenPr && !isFinish"><a id="btn_select" @click="openSeletedField">選択する</a></div>
            <div class="btn1 submit-btn" v-if="isOpenMoodStatus && !isFinish"><a id="btn_select" @click="isMoodStatus = true">ひとことを入力する</a></div>
            <div class="btn1 submit-btn" v-if="isOpenPr && !isFinish"><a id="btn_select" @click="isUserStatus = true">自己紹介を入力する</a></div>
        </div>
        <!-- Job selection -->
        <nav id="job_selection" v-if="isJob">
            <div class="nav-menu">
                <div class="nav-title">職業</div>
                <div class="nav-can"><a @click="isJob = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.job" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_JOB, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>

        <!-- Income selection -->
        <nav id="income_selection" v-if="isIncome">
            <div class="nav-menu">
                <div class="nav-title">年収</div>
                <div class="nav-can"><a @click="isIncome = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.income" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_INCOME, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>

        <!-- holidays selection -->
        <nav id="holidays_selection" v-if="isHolidays">
            <div class="nav-menu">
                <div class="nav-title">休日</div>
                <div class="nav-can"><a @click="isHolidays = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.holidays" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_HOLIDAYS, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>

        <!-- Meeting_condition selection -->
        <nav id="meeting_condition_selection" v-if="isMeetingCondition">
            <div class="nav-menu">
                <div class="nav-title">出会うまでの希望</div>
                <div class="nav-can"><a @click="isMeetingCondition = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.meeting_condition" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_MTG_CON, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>

        <!-- Purpose selection -->
        <nav id="purpose_selection" v-if="isPurpose">
            <div class="nav-menu">
                <div class="nav-title">会ったときの希望</div>
                <div class="nav-can"><a @click="isPurpose = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.purpose" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_PURPOSE, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>
        <!-- Style selection -->
        <nav id="purpose_selection" v-if="isStyle">
            <div class="nav-menu">
                <div class="nav-title">体型</div>
                <div class="nav-can"><a @click="isStyle = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.style" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_STYLE, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>
        <!-- Height selection -->
        <nav id="purpose_selection" v-if="isHeight">
            <div class="nav-menu">
                <div class="nav-title">身長</div>
                <div class="nav-can"><a @click="isHeight = false">キャンセル</a></div>
                <ul>
                    <li v-for="(item, index) in metadata.user_profile_list.height" :key="index" :value="item.value"><a @click="setValue(constants.COOKIE_SESSION_HEIGHT, item.value)">{{ item.name }}</a></li>
                </ul>
            </div>
        </nav>
    </div>
    <div id="mood_status_page" v-if="isMoodStatus">
        <header v-if="!isShowAutoWord">ひとこと<div class="h-left"><a @click="closeMoodStatus"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap" v-if="!isShowAutoWord">
            <div class="txt-area">
                <div class="btn4"><a @click="isShowAutoWord = true">例文からひとこと作成</a></div>
                <textarea maxlength="20" @keyup="checkChangeMoodStatus" v-model="moodStatus" id="mood_status_content" class="aword1" placeholder="ひとことを書く"></textarea>
                <p class="b">書き方でお困りですか？</p>
                <div class="btn4"><a @click="showDemoUserDetail()"><i class="fas fa-user"></i>　他の会員のひとことを見る</a></div>
            </div>
            <div :class="moodStatus && isChangeMoodStatus ? 'btn1' : 'btn3'"><a id="btn_save_mood_status" @click="saveMoodStatus">保存</a></div>
        </div>
        <autoWord :isShow="isShowAutoWord" @getValue="getMoodStatus" @close="isShowAutoWord = false"></autoWord>
    </div>

    <div id="pr_page" v-if="isUserStatus">
        <header v-if="!isShowAutoWordUserStatus && !isShowDemoUserStatus1">自己紹介<div class="h-left"><a @click="closeStatus"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap" v-if="!isShowAutoWordUserStatus  && !isShowDemoUserStatus1">
            <div class="txt-area">
                <div class="btn4"><a @click="isShowAutoWordUserStatus = true">例文から自己紹介作成</a></div>
                <textarea @keyup="checkChangeUserStatus" maxlength="500" :disabled="pr && pr.length > 500 ? true: false" v-model="pr" class="self-introduction1" id="pr_content" placeholder="自己紹介文を入力"></textarea>
                <div class="clearfix">
                    <div class="self-introduction2">※20文字以上入力してください</div>
                    <div class="self-introduction3">{{ pr ? pr.length : 0}}/500</div>
                </div>
                <p class="b">書き方でお困りですか？</p>
                <div class="btn4"><a @click="isShowDemoUserStatus1 = true"><i class="fas fa-question-circle"></i>　魅力的な自己紹介の書き方を見る</a>
                </div>
                <div class="btn4"><a @click="showDemoUserDetail()"><i class="fas fa-user"></i>　他の会員の自己紹介を見る</a></div>
            </div>
            <div :class="checkUserStatus() ? 'btn1' : 'btn3'"><a id="btn_save_pr" @click="saveUserStatus">保存</a></div>
        </div>
        <autoWordUserStatus :isShow="isShowAutoWordUserStatus" @getValue="getUserStatus" @close="isShowAutoWordUserStatus = false"></autoWordUserStatus>
        <demoUserStatus1 :isShow="isShowDemoUserStatus1" :sex="user.sex" @close="isShowDemoUserStatus1 = false"></demoUserStatus1>
    </div>
</div>
<detail v-if="isShowDetail" :idUser="idUser" @close="closeDetail"></detail>
</template>

<script>
import CONSTANTS from '@/constants'
import autoWord from "../../profile/components/autoWord.vue"
import autoWordUserStatus from "../../profile/components/autoWordUserStatus.vue"
import demoUserStatus1 from "../../profile/components/demoUserStatus1"
import detail from "./detail"
import {
    getStepRegister,
    getSession,
    setSession,
} from '@/auth'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['submit'],
    components: {
        autoWord,
        autoWordUserStatus,
        demoUserStatus1,
        detail
    },
    data: () => ({
        isIncome: false,
        isHolidays: false,
        isMeetingCondition: false,
        isPurpose: false,
        isJob: false,
        isStyle: false,
        isHeight: false,
        isMycomment2: false,
        isMoodStatus: false,
        isUserStatus: false,
        isOpenMoodStatus: false,
        isOpenPr: false,
        isFinish: false,
        formData: {
            job: null,
            income: null,
            holidays: null,
            meeting_condition: null,
            purpose: null,
            mood_status: null,
            user_status: null,
            height: null,
            style: null,
        },
        questions: null,
        user: null,
        isShowAutoWord: false,
        isShowAutoWordUserStatus: false,
        isShowDemoUserStatus1: false,
        MALE: CONSTANTS.MALE,
        FEMALE: CONSTANTS.FEMALE,
        constants: CONSTANTS,
        pr: null,
        moodStatus: null,
        isChangeMoodStatus: false,
        isChangeUserStatus: false,
        isShowDetail: false,
        idUser: null,
        scrollPosition: 0,
        isEdit: false,
    }),
    mounted() {
        this.init()

        this.loadSavedData()
        setTimeout(() => {
            window.scrollTo(0, 0);
            // window.scrollTop = window.scrollHeight;
        }, 100)
    },
    watch: {
        isShow(val) {
            if (val) {
                this.init()
            }
        },
        isAnyDialogOpen(val) {
            const body = document.getElementsByTagName('body')[0];
            const html = document.getElementsByTagName('html')[0];

            if (val) {
                this.scrollPosition = window.scrollY;
                body.style.position = "fixed";
                body.style.overflow = "hidden";
                html.style.height = "calc(100vh - 1px)";
                body.style.top = "-" + this.scrollPosition + "px";
            } else {
                body.style.position = "";
                body.style.overflow = "auto";
                html.style.height = "";
                body.style.top = "";
                setTimeout(() => {
                    window.scrollTo(0, this.scrollPosition)
                }, 1);
            }
        },

        isMoodStatus(val) {
            if (val) {
                this.scrollPosition = window.scrollY;
                window.scrollTo(0, 0);
            } else {
                setTimeout(() => {
                    window.scrollTo(0, this.scrollPosition)
                }, 1);
            }
        },

        isUserStatus(val) {
            if (val) {
                this.scrollPosition = window.scrollY;
                window.scrollTo(0, 0);
            } else {
                setTimeout(() => {
                    window.scrollTo(0, this.scrollPosition)
                }, 1);
            }
        },

        isShowDemoUserStatus1() {
            window.scrollTo(0, 0);
        },
        
        isShowAutoWord() {
            window.scrollTo(0, 0)
        },

        isShowDetail() {
            window.scrollTo(0, 0)
        },

        isShowAutoWordUserStatus() {
            window.scrollTo(0, 0)
        }
    },

    computed: {
        ...mapGetters(["metadata", 'defaultToken', 'userDetail', 'defaultToken']),

        isAnyDialogOpen() {
            return this.isHeight || this.isStyle || this.isJob || this.isIncome || this.isHolidays || this.isMeetingCondition || this.isPurpose
        }
    },
    methods: {
        ...mapActions({
            'userProfile': 'user/userProfile',
        }),
        update() {

        },
        async init() {
            this.$store.dispatch("route/showLoading")
            if (!this.userDetail && getStepRegister() == CONSTANTS.STEP_REGISTER_UPDATE_INFO) {
                await this.userProfile({
                    token: this.defaultToken
                }).then(data => {
                    this.user = data
                })
            } else if (getStepRegister() == CONSTANTS.STEP_REGISTER_UPDATE_INFO) {
                this.user = this.userDetail
            }
            if (parseInt(getStepRegister()) == CONSTANTS.STEP_REGISTER_UPDATE_INFO && this.user) {
                this.getQuestionData()
            }
            this.$store.dispatch("route/hideLoading")
        },
        setValue(key, value) {
            // Save answer to session
            setSession(key, value)

            if (key === CONSTANTS.COOKIE_SESSION_JOB) {
                this.setJob(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_HEIGHT) {
                this.setHeight(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_STYLE) {
                this.setStyle(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_INCOME) {
                this.setIncome(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_HOLIDAYS) {
                this.setHolidays(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_MTG_CON) {
                this.setMeetingCondition(value)
            }
            if (key === CONSTANTS.COOKIE_SESSION_PURPOSE) {
                this.setPurpose(value)
            }
            
            this.scrollToBottom();
        },
        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        async getQuestionData() {
            this.$store.dispatch("route/showLoading")
            await this.$store.dispatch('user/getQuestionData', {
                token: this.defaultToken
            }).then(data => {
                this.questions = data

            }).catch(err => {
                this.$store.dispatch('login/resetAccessToken');

                let temp = this;
                setTimeout(function () {
                    temp.getQuestionData();
                }, 1000);
            })
            this.$store.dispatch("route/hideLoading")
        },

        getQuestionItem(str, key) {
            return str.replace('職業', '<span>職業</span>').
            replaceAll('年収', '<span>年収</span>').
            replaceAll('う。', 'う。<br>').
            replace('休日', '<span>休日</span>').
            replace('出会うまでの希望', '<span>出会うまでの希望</span>').
            replace('初めてのデート', '<span>初めてのデート</span>').
            replace('変更する場合は、マイページの', '<span>変更する場合は、マイページの</span>').
            replace('プロフィール編集から変更してください。', '<span>プロフィール編集から変更してください。</span>').
            replace('ひとこと', '<span>ひとこと</span>').
            replace('自己紹介', '<span>自己紹介</span>').
            replace('身長', '<span>身長</span>').
            replace('体型', '<span>体型</span>').
            replace('プロフィール入力は以上です。', 'プロフィール入力は以上です。<br>').
            replace('以下がプロフィールです。', '以下がプロフィールです。<br>').
            replace('後から変更もできます。', '<br>後から変更もできます。').
            replace(/(\\r)*\\n/g, '');
        },

        openSeletedField() {
            if (this.isHeight === false && !this.formData.height && parseInt(this.user.sex) === CONSTANTS.FEMALE) {
                this.isHeight = true
            }
            if (this.isStyle === false && this.formData.height && !this.formData.style && parseInt(this.user.sex) === CONSTANTS.FEMALE) {
                this.isStyle = true
            }
            if ((this.isJob === false && !this.formData.job && parseInt(this.user.sex) !== CONSTANTS.FEMALE) ||
                (this.isJob === false && this.formData.height && this.formData.style && !this.formData.job && parseInt(this.user.sex) === CONSTANTS.FEMALE)) {
                this.isJob = true
            }
            if (this.isIncome === false && !this.formData.income && this.formData.job && parseInt(this.user.sex) !== CONSTANTS.FEMALE) {
                this.isIncome = true
            }
            if ((this.isHolidays === false && this.formData.income && !this.formData.holidays && parseInt(this.user.sex) !== CONSTANTS.FEMALE) ||
                (this.isHolidays === false && this.formData.job && !this.formData.holidays && parseInt(this.user.sex) === CONSTANTS.FEMALE)) {
                this.isHolidays = true
            }
            if (this.isMeetingCondition === false && this.formData.holidays && !this.formData.meeting_condition) {
                this.isMeetingCondition = true
            }
            if (this.isPurpose === false && this.formData.meeting_condition && !this.formData.purpose) {
                this.isPurpose = true
            }
        },
        checkUserStatus() {
            if (this.pr && this.pr.length >= 20 && this.isChangeUserStatus) {
                return true
            } else false
        },
        saveMoodStatus() {
            if (!this.moodStatus || !this.isChangeMoodStatus) return
            // Save answer to session
            setSession(CONSTANTS.COOKIE_SESSION_MOOD_STATUS, this.moodStatus)
 
            this.setMoodStatus(this.moodStatus)
            this.scrollToBottom();
        },
        saveUserStatus() {
            if (!this.pr || this.pr.length < 20 || !this.isChangeUserStatus) {
                return
            }

            // Save answer to session
            setSession(CONSTANTS.COOKIE_SESSION_PR, this.pr)

            this.setPr(this.pr)
            this.scrollToBottom();
        },
        getMoodStatus(value) {
            this.moodStatus = value;
            this.isChangeMoodStatus = true
            this.isShowAutoWord = false;
        },
        getUserStatus(value) {
            this.pr = value;
            this.isChangeUserStatus = true
            this.isShowAutoWordUserStatus = false;
        },
        
        closeMoodStatus() {
            this.isMoodStatus = false
            this.moodStatus = this.formData.mood_status
            // setTimeout(() => {
            //     window.scrollTo(0, document.body.scrollHeight);
            //     // window.scrollTop = window.scrollHeight;
            // }, 1)
        },
        closeStatus() {
            this.isUserStatus = false
            this.pr = this.formData.user_status
            // setTimeout(() => {
            //     window.scrollTo(0, document.body.scrollHeight);
            //     // window.scrollTop = window.scrollHeight;
            // }, 1)
        },
        checkChangeMoodStatus() {
            this.isChangeMoodStatus = true
        },
        checkChangeUserStatus() {
            this.isChangeUserStatus = true
        },
        showDemoUserDetail() {
            document.getElementById('main').style.display = "none"
            this.isShowDetail = true
            if (this.user.sex == this.MALE) {
                this.idUser = this.metadata.kara_male;
            } else {
                this.idUser = this.metadata.kara_female;
            }
        },
        closeDetail() {
            document.getElementById('main').style.display = "unset"
            this.isShowDetail = false
        },

        // If have saved question data => load it
        loadSavedData() {
            if (getSession(CONSTANTS.COOKIE_SESSION_JOB)) {
                this.setJob(getSession(CONSTANTS.COOKIE_SESSION_JOB))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_HEIGHT)) {
                this.setHeight(getSession(CONSTANTS.COOKIE_SESSION_HEIGHT))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_STYLE)) {
                this.setStyle(getSession(CONSTANTS.COOKIE_SESSION_STYLE))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_INCOME)) {
                this.setIncome(getSession(CONSTANTS.COOKIE_SESSION_INCOME))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_HOLIDAYS)) {
                this.setHolidays(getSession(CONSTANTS.COOKIE_SESSION_HOLIDAYS))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_MTG_CON)) {
                this.setMeetingCondition(getSession(CONSTANTS.COOKIE_SESSION_MTG_CON))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_PURPOSE)) {
                this.setPurpose(getSession(CONSTANTS.COOKIE_SESSION_PURPOSE))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_MOOD_STATUS)) {
                this.setMoodStatus(getSession(CONSTANTS.COOKIE_SESSION_MOOD_STATUS))
            }

            if (getSession(CONSTANTS.COOKIE_SESSION_PR)) {
                this.setPr(getSession(CONSTANTS.COOKIE_SESSION_PR))
            }
        },

        setJob(val) {
            this.isJob = false
            this.formData.job = val
        },

        setHeight(val) {
            this.isHeight = false
            this.formData.height = val
        },

        setStyle(val) {
            this.isStyle = false
            this.formData.style = val
        },

        setIncome(val) {
            this.isIncome = false
            this.formData.income = val
        },

        setHolidays(val) {
            this.isHolidays = false
            this.formData.holidays = val
        },

        setMeetingCondition(val) {
            this.isMeetingCondition = false
            this.formData.meeting_condition = val
        },

        setPurpose(val) {
            this.isPurpose = false
            this.formData.purpose = val
            this.isOpenMoodStatus = true
        },

        setMoodStatus(val) {
            this.moodStatus = val
            this.formData.mood_status = this.moodStatus
            this.isMoodStatus = false
            this.isOpenMoodStatus = false
            this.isOpenPr = true
            this.isChangeMoodStatus = false
        },

        setPr(val) {
            this.pr = val
            this.isChangeUserStatus = false
            this.formData.user_status = this.pr
            this.isUserStatus = false
            this.isOpenUserStatus = false,
            this.isFinish = true
        },

        scrollToBottom() {
            if (!this.isEdit) {
                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                    // window.scrollTop = window.scrollHeight;
                }, 10)
            } else {
                this.isEdit = false
            }
        }


    }
}
</script>

<style lang="css" scoped>
nav {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: unset
}

.nav-menu {
    height: 40%;
}

.nav-menu ul {
    overflow-y: auto;
    height: 87%;
}

.submit-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
}
.btn4 a {
    color: #757575;
}
ul li:last-child {
    margin-bottom: 50px;
}
</style>
